import React, { createContext } from 'react';

import { reducer } from './reducer';

const initialState = {
	init: true,
	loading: true,
	series: null,
	currentPage: 1,
	cardsPerPage: 3,
};

// Settings.
export const SettingsContext = createContext({});

// Data Provider
export const DataContext = createContext();
export const DispatchContext = createContext();
export function DataProvider(props) {
	const [state, dispatch] = React.useReducer(reducer, initialState);

	const { children } = props;

	return (
		<DataContext.Provider value={state}>
			<DispatchContext.Provider value={dispatch}>
				{children}
			</DispatchContext.Provider>
		</DataContext.Provider>
	);
}

export const useSettings = () => React.useContext(SettingsContext);
export const useData = () => React.useContext(DataContext);
export const useDispatch = () => React.useContext(DispatchContext);
export const useStore = () => ({
	state: useData(),
	dispatch: useDispatch(),
});
